export function buildProjectsPageQueryV1(workspaceId: number)
{
	return {
		'$type': 'TCh.Domain.Projects.Queries.ProjectsPageQueryV1, TCh.Domain.Projects',
		'WorkspaceId': workspaceId,
	}
}

export function buildProjectTemplateDownloadPageQueryV1(accessKey: string)
{
	return {
		'$type': 'TCh.Domain.Projects.Queries.ProjectTemplateDownloadPageQueryV1, TCh.Domain.Projects',
		'AccessKey': accessKey,
	}
}


export function buildProjectByIdQueryV1(workspaceId: number, projectId: number)
{
	return {
		'$type': 'TCh.Domain.Projects.Queries.ProjectByIdQueryV1, TCh.Domain.Projects',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId
	}
}

export function buildProjectTemplateLinksQueryV1(workspaceId: number, projectId: number)
{
	return {
		'$type': 'TCh.Domain.Projects.Queries.ProjectTemplateLinksQueryV1, TCh.Domain.Projects',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId
	}
}

export function buildProjectUsersTagsQueryV1(workspaceId: number, projectId: number)
{
	return {
		'$type': 'TCh.Domain.Projects.Queries.ProjectUsersTagsQueryV1, TCh.Domain.Projects',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId
	}
}